module.exports = __webpack_public_path__ + "img/grid_layout_3_3.248cb9bc.svg";